angular.module('elfium').constant('ELFIUM_SELECT_OPTIONS', {
	zeme: {
        cesko: 'Česko',
        slovensko: 'Slovensko', 
        madarsko: 'Maďarsko'
    },
    krajCZ: ['Praha', 'Jihomoravský', 'Jihočeský', 'Pardubický', 'Královéhradecký', 'Vysočina', 'Karlovarský', 'Liberecký', 'Olomoucký', 'Plzeňský', 'Středočeský', 'Moravskoslezský', 'Ústecký', 'Zlínský'],
    krajSK: ['Bratislavský', 'Trnavský', 'Trenčínský', 'Nitranský', 'Žilinský', 'Banskobystrický', 'Prešovský', 'Košický'],
    pocetZamestnancu: ['pocet1', 'pocet2'],
    trh: ['trh1', 'trh2'],
    status: ['Nevím', 'Rozhodovač', 'Ovlivnovač', 'Nemá'],
    obchodnik: ['xxx', 'yyy'],
    divize: ['ELF', 'HR', 'ALS', 'EU I', 'EU VZ'],
    titulPred: ["Bc.", "BcA.", "ICDr.", "Ing.", "Ing. arch.", "JUDr.", "MDDr.", "MgA.", "Mgr.", "MSDr.", "MUDr.", "MVDr.", "PaedDr.", "PharmDr.", "PhDr.", "PhMr.", "RCDr.", "RNDr.", "RSDr.", "RTDr.", "ThDr.", "ThLic.", "ThMgr.", "prof.", "doc.", "Dr."],
    titulZa: ["Ph.D.", "Th.D.", "CSc.", "DrSc.", "dr. h. c.", "DiS."]
}).constant('ELFIUM_ROUTE_LABELS', {
    '/dashboard': 'Dashboard',
    '/contacts': 'Osoby',
    '/companies': 'Firmy',
    '/businessCases': 'Obchodní případy',
    '/tasks': 'Úkoly',
    '/login': 'Přihlášení',
    '/register': 'Registrace'
}).constant('ELFIUM_USER_TYPES', {
    ADMIN: 'Admin',
    ASSISTANT: 'Asistent',
    CONSULTANT: 'Konzultant'
}).constant('PAGE', {
    '/contacts': 0,
    '/companies': 1,
    '/tasks': 2,
    '/businessCases': 3
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumConstants.ts